var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFunnel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.968 0C1.386 0 .953.208.748.586.543.964.61 1.43.939 1.9L5.745 8.41c.007.014.019.061.02.075l-.005 2.298c0 .288.133.632.32.821l2.326 2.137c.168.171.338.258.505.258.288 0 .58-.279.58-.901v-4.61c0-.017.013-.063.018-.076l4.814-6.514c.329-.47.398-.935.193-1.313C14.312.208 13.88 0 13.296 0H1.962",
    fill: "#223762",
    fillRule: "nonzero"
  })));
}

export default SvgFunnel;